import { ManageInvestorDetailsContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/InvestorDetails';
import { updateMipPaymentData } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Payments/Payments.api';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useWrappedRequest } from '@dealstack/frontend/shared/other/react/ApiWrapper';
import { useContext, useMemo } from 'react';
import { TransactionState } from '@dealstack/shared/lib/generated';

export const useFundsDashcardController = () => {
	const tMipManage = useTranslationMipManage();
	const updatePaymentRequest = useWrappedRequest(updateMipPaymentData);
	const { investorDetailsData, refreshMIPInvestorDetailsData } = useContext(
		ManageInvestorDetailsContext
	);

	const isAnyInvestmentWorkflowExist =
		investorDetailsData?.paymentInformation?.isAnyInvestmentWorkflowExist;
	const isSingleInvestmentWorkflow =
		investorDetailsData?.paymentInformation?.isSingleInvestmentWorkflow;
	const isAllPaymentsCompleted = investorDetailsData?.paymentInformation?.isAllPaymentsCompleted;
	const isSomePaymentsPending = investorDetailsData?.paymentInformation?.isSomePaymentsPending;
	const isSinglePaymentPending = investorDetailsData?.paymentInformation?.isSinglePaymentPending;
	const investmentWorkflowId = investorDetailsData?.paymentInformation?.investmentWorkflowId;

	const showStatusChip = isAnyInvestmentWorkflowExist && isAllPaymentsCompleted;

	const onApprovePayment = () => {
		if (!investmentWorkflowId) {
			return;
		}
		updatePaymentRequest
			.fetch({ status: TransactionState.COMPLETED, id: investmentWorkflowId })
			.onSuccess(() => {
				showToastV2({
					title: tMipManage('investors.dashcards.funds_approved'),
				});
				refreshMIPInvestorDetailsData();
			});
	};

	const contentValues = useMemo(() => {
		if (!isAnyInvestmentWorkflowExist) {
			return;
		}

		const value = investorDetailsData?.fundAmount;

		if (isSingleInvestmentWorkflow) {
			const text = tMipManage(
				`investors.dashcards.${isAllPaymentsCompleted ? 'funds_received' : 'funds_due'}`
			);
			return { text, value };
		}

		if (isAllPaymentsCompleted) {
			return {
				text: tMipManage('investors.dashcards.total_funds_received'),
				value,
			};
		}

		if (!investmentWorkflowId) {
			return;
		}
		return {
			text: tMipManage('investors.dashcards.funds_due_investment_id', {
				id: investmentWorkflowId,
			}),
			value,
		};
	}, [investorDetailsData?.paymentInformation]);

	return {
		contentValues,
		isSingleInvestmentWorkflow,
		showStatusChip,
		isAllPaymentsCompleted,
		isSomePaymentsPending,
		isSinglePaymentPending,
		onApprovePayment,
		disableApproveButton: updatePaymentRequest.isLoading,
		investorDetailsData,
	};
};
